export const instrumentationShiftRequestType = {
    Unspecified: "Unspecified",
    Offer: "Offer" /* This instrumentation value is different from Service type of HandOff */,
    Swap: "Swap",
    TimeOff: "TimeOff",
    OpenShifts: "OpenShifts",
    AdminOpenShift: "AdminOpenShift",
    EmployeeOpenShift: "EmployeeOpenShift",
    CrossLocationOpen: "CrossLocationOpen",
    ApproveDenyTimeOff: "ApproveDenyTimeOff",
    GetTimeOffBalance: "GetTimeOffBalance",
    CreateTimeOff: "CreateTimeOff"
};